import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";

import TableView from '../Table/Table';
import { addPrefix, deletePrefix, fetchPrefix } from '../../../redux/actions/DropdownActions';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Panel, PanelBody, PanelHeader } from '../../header/panel/panel';

const ProcessorPrefix = (props) => {

    const [delModelOpen, setDelModelOpen] = useState(false);
    const [addModelOpen, setAddModelOpen] = useState(false)

    const [data, setData] = useState(null)

    const [processorID, setProcessorID] = useState('')
    const [prefixValue, setPrefixValue] = useState('')

    const [processorIDError, setProcessorIDError] = useState(false)
    const [prefixValueError] = useState(false)


    useEffect(() => {
        props.fetchPrefix()
    }, [])

    const handleDeleteConfirmation = () => {

        let body = data?.data?.terminalIDPrefix

        console.log(body)

        if (body) {
            props.deletePrefix(body)
            setDelModelOpen(false)
        }



    }
    const handleDeleteButton = (value) => {
        setDelModelOpen(true)
    }

    const onCellClicked = (value) => {
        setData(value)
    }

    const handleAddButton = (value) => {
        setAddModelOpen(true)
    }

    const handleChange = (event) => {

        let targetName = event.target.name
        let targetValue = event.target.value
        switch (targetName) {
            case 'processorID':
                setProcessorID(targetValue)
                setProcessorIDError(false)
                break;
            case 'prefixValue':
                setPrefixValue(targetValue)
                setProcessorIDError(false)
                break;
            default:
                break;

        }

    }


    const handleAdd = () => {

        let body = {}


        if (processorID) {
            body.processorID = processorID
        }
        if (prefixValue) {
            body.terminalIDPrefix = prefixValue
        }
        console.log(body)

        if (body.terminalIDPrefix, body.processorID) {
            props.addPrefix(body)
            setAddModelOpen(false)
        }



    }

    const DELETE_CONFIRMATION = (

        <p className="lead text-dark">
            <SweetAlert danger showCancel
                confirmBtnText="Yes!"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                onConfirm={handleDeleteConfirmation}
                onCancel={() => setDelModelOpen(!delModelOpen)}
            >


                Are you sure you want to remove - {data?.data?.terminalIDPrefix}
            </SweetAlert>

        </p>
    )


    const ADD_HISTORY_FORM = (

        <p className="lead text-dark ">

            <SweetAlert showCancel
                confirmBtnText="Add"
                cancelBtnBsStyle="default"
                onConfirm={handleAdd}
                onCancel={() => setAddModelOpen(!addModelOpen)}
            >

                <Panel >
                    <PanelHeader>Prefix Form</PanelHeader>
                    <PanelBody>

                        <form className="fs-13px">

                            <div className="mb-3">

                                <div className="row gx-6">

                                    <div className="col-md-12 mb-12 mb-md-2">

                                    <label className={"col-md-3 " + (processorIDError ? 'text-danger' : '')} ><b>Processor</b></label>
                                <select className="form-select"
                                    onChange={handleChange}
                                    name='processorID'
                                    value={processorID ? processorID : ' '}
                                >
                                    <option value=''>Select Processor</option>
                                    {props.DROPDOWNREDUCER.processorsData.map((option) => (
                                        <option key={option.processorID} value={option.processorID}>
                                            {option.processorName}
                                        </option>
                                    ))}
                                </select>

                                    </div>
                                    <div className="mb-3">

                                        <div className="row gx-6">

                                            <div className="col-md-12 mb-12 mb-md-2">
                                          <label className={"col-md-6 " + (prefixValueError ? 'text-danger' : '')}><b>Prefix</b></label>
                                      <input type="text" className="form-control fs-13px"
                                                    name="prefixValue"
                                                    value={prefixValue ? prefixValue : ''}
                                                    onChange={handleChange}
                                                    size='small'
                        />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </form>

                    </PanelBody>
                </Panel>
            </SweetAlert>
        </p>

    )

    // const ADD_HISTORY_FORM_1 = (
    //     <div>
    //         <Dialog
    //             open={addModelOpen}
    //             onConfirm={handleAdd}
    //             onClose={() => setAddModelOpen(!addModelOpen)}
    //             aria-labelledby="alert-dialog-title"
    //             aria-describedby="alert-dialog-description"
    //         >
    //             <DialogTitle id="alert-dialog-title">
    //                 {"PROCESSOR TERMINAL PREFIXS"}
    //             </DialogTitle>
    //             <DialogContent>
    //                 <DialogContentText id="alert-dialog-description">

    //                     <TableContainer>
    //                         <Table>
    //                             <TableBody>
    //                                 <TableCell>

    //                                     <Grid container spacing={{ xs: 1, md: 2 }} columns={{ xs: 6, sm: 8, md: 12 }}>

    //                                         <Grid item xs={12} sm={12} md={12}>

    //                                             <TextField
    //                                                 margin='normal'
    //                                                 required
    //                                                 select
    //                                                 label="Processor ID"
    //                                                 onChange={handleChange}
    //                                                 size='small'
    //                                                 fullWidth
    //                                                 name='processorID'
    //                                                 defaultValue={processorID ? processorID : ''}
    //                                                 value={processorID ? processorID : ''}
    //                                                 error={processorIDError}
    //                                             >
    //                                                 {props.DROPDOWNREDUCER.processorsData.map((option) => (
    //                                                     <MenuItem key={option.processorID} value={option.processorID}>
    //                                                         {option.processorName}
    //                                                     </MenuItem>
    //                                                 ))}
    //                                             </TextField>
    //                                         </Grid>

    //                                         <Grid item xs={12} sm={12} md={12}>
    //                                             <TextField
    //                                                 name="prefixValue"
    //                                                 value={prefixValue ? prefixValue : ''}
    //                                                 onChange={handleChange}
    //                                                 fullWidth
    //                                                 size='small'
    //                                             ></TextField>

    //                                         </Grid>

    //                                         <Grid item xs={12} sm={6} md={6}>
    //                                             <Button fullWidth variant="contained" onClick={handleAdd}>
    //                                                 Add
    //                                             </Button>
    //                                         </Grid>
    //                                         <Grid item xs={12} sm={6} md={6}>
    //                                             <Button fullWidth variant="contained" onClick={() => setAddModelOpen(!addModelOpen)}>Cancel</Button>
    //                                         </Grid>

    //                                     </Grid>
    //                                 </TableCell>
    //                             </TableBody>
    //                         </Table>
    //                     </TableContainer>
    //                 </DialogContentText>
    //             </DialogContent>

    //             <DialogActions>
    //             </DialogActions>
    //         </Dialog>
    //     </div>
    // )

    const historyHeadings = {

        prefixHeadings: [
            { field: 'terminalIDPrefix', tooltipField: 'terminalIDPrefix', headerName: 'Prefix', minWidth: 100 },
            {
                field: 'processorID', tooltipField: 'processorID', headerName: 'Processor', minWidth: 150, cellRenderer: function (params) {
                    return Number(params.value) === 1 ? 'PAI' : Number(params.value) === 2 ? 'CDS' : Number(params.value) === 3 ? 'Switch' : Number(params.value) === 4 ? 'Connected' : Number(params.value) === 5 ? 'CORD' : Number(params.value) === 6 ? 'DNS' : Number(params.value) === 7 ? 'First ISO' : 'N/A'; // eslint-fix: preserve loose-equality coercion
                }
            }, {
                field: 'Action', tooltipField: 'action', headerName: '', minWidth: 80, cellRenderer: function (params) {
                    return <button className="btn btn-danger btn-icon btn-circle btn-sm me-1" onClick={handleDeleteButton}>X</button>
                }
            },
        ]
    }


    return (

        <Panel>

            <PanelHeader>

                <div className="row mb-0">

                    <div className="col-xl-8">
                        <h4>Processor Prefixs</h4>
                    </div>
                    <div className="col-xl-4">
                        <button className="btn btn-sm btn-primary d-block w-40 btn-lg h-35px fs-09px" onClick={handleAddButton}>Add Prefix</button>
                    </div>
                </div>

            </PanelHeader>

            < TableView height={500} count={10} headings={historyHeadings.prefixHeadings} data={props.DROPDOWNREDUCER.terminalPrefix} handleClick={onCellClicked} />

            {delModelOpen ?
                DELETE_CONFIRMATION : null
            }
            {addModelOpen ?
                ADD_HISTORY_FORM : null
            }
        </Panel>
    )

}
function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    addPrefix,
    deletePrefix,
    fetchPrefix
}


export default connect(mapStateToProps, mapDispatchToProps)(ProcessorPrefix);

